import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InfoListItem from './InfoListItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  infoContainer: {
    paddingTop: '4.375em',
    paddingBottom: '0.375em',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    }
  },
  infoContainerMobile: {
    paddingBottom: '0.375em',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    }
  },
  infoBox: {
    backgroundColor: '#033349',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    paddingTop: '2.0625em',
    paddingBottom: '2.0625em',
    paddingLeft: '9em',
    paddingRight: '9em',
    flex: 1,
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'inherit'
    }
  },
  infoBoxMobile: {
    backgroundColor: '#033349',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    paddingTop: '2.0625em',
    paddingBottom: '2.0625em',
    paddingLeft: '1em',
    paddingRight: '1em',
    flex: 1,
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'inherit'
    }
  },
  infoList: {
    justifyContent: 'flex-start',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-end',
      paddingLeft: '4.688em',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      letterSpacing: '0.035em',
      marginBottom: '0.323em',
      marginTop: 30
    }
  }
});

interface InfoItemProps {
  title: string;
  content: string;
}

interface InfoContainerProps {
  items: InfoItemProps[];
  isMobile?: boolean;
}

const InfoContainer: React.SFC<WithStyles & InfoContainerProps> = ({
  classes,
  isMobile,
  items
}) => {
  return (
    <Grid item container className={isMobile === false ? classes.infoContainer : classes.infoContainerMobile}>
      <Grid item container direction="column" className={isMobile === false ? classes.infoBox : classes.infoBoxMobile}>
        <Grid item>{localizations.infoContainer.infoboxTitle}</Grid>
        <Grid item>
          {localizations.infoContainer.infoboxDesc1}
          <br /><br />
          {localizations.infoContainer.infoboxDesc2}
          <br /><br />
          {localizations.infoContainer.infoboxDesc3}
          <br /><br />
          {localizations.infoContainer.infoboxDesc4}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(InfoContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/InfoContainer.tsx